import { ColorTransform } from "./../display/ColorTransform";

const convertHexToRgba = (color: string | number, alpha: number = 1): string => {
    const colorString = ColorTransform.colorNumToString(color);
    const RGBColor = ColorTransform.hexToRgb(colorString);
    return createjs.Graphics.getRGB(RGBColor.r, RGBColor.g, RGBColor.b, alpha);
};

export { convertHexToRgba }